/**
 * 客户分配记录,客户变更记录
 * @author ruikangmao
 */
import React, { FunctionComponent, useMemo } from 'react'
import { Tabs } from 'antd'
import { PageHeader } from '@components'
import AssignRecord from './AssignRecord'
import AssignExamine from './AssignExamine'
import store, { globalStore, sessionStore } from '@store'
import { useShallow } from 'zustand/shallow'
import { moduleId } from '@configs'

const CustomerAssignRecordPage: FunctionComponent = () => {
  const authPointMap = globalStore(s => s.authPointMap)
  const { isPermissableBelongModule } = sessionStore(
    useShallow(s => ({
      isPermissableBelongModule: s.isPermissableBelongModule
    }))
  )
  const items = useMemo(() => {
    const list = [
      {
        label: '客户变更',
        key: 'assign-record',
        children: <AssignRecord />,
      },
    ]
    if (isPermissableBelongModule([moduleId.MID_LONG_TAIL_ID]) && authPointMap.noUinCustomerMerge.result) {
      list.push({
        label: '客户合并审批',
        key: 'assign-examine',
        children: <AssignExamine />,
      })
    }
    return list
  }, [authPointMap.noUinCustomerMerge.result])
  return (
    <>
      <PageHeader title="客户变更记录" footer={(<Tabs items={items} />)} />
    </>
  )
}
export default CustomerAssignRecordPage
